<template>
  <div>
    <div @click="showPopup" class="popups">目录</div>
    <van-popup
      duration="0.2"
      v-model="show"
      position="right"
      :style="{ height: '100%' }"
    >
      <ul class="list_s">
        <li
          :class="indexNav === index ? 'accti' : ''"
          @click="btn(index)"
          v-for="(item, index) in list"
          :key="item.index"
        >
          {{ item }}
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      show: false,
      indexNav: 0,
      scolltop: [],
      timer: null,
      list: [],
      newlist: [],
    };
  },
  methods: {
    showPopup() {
      this.show = true;
    },
    // 点击过渡滚动
    btn(index) {
      this.show = false;
      if (index != this.list.length - 1) {
        this.indexNav = index;
      }
      if (index == this.list.length - 1) {
        $("html, body").animate({ scrollTop: 0 }, 400);
      } else {
        this.$nextTick(() => {
          // 每次点击调用最新top值
          this.sss(index);
          // 最后赋值为空，重置
          this.scolltop = [];
        });
      }
    },
    // 滚动条逻辑处理
    sss(index) {
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          // 获取dom
          let arr = $(".container");
          let txt = $(".badge");
          let music = $(".container")[2].clientHeight;
          for (let i = 2; i < arr.length; i++) {
            this.scolltop.push(arr[i].offsetTop);
          }
          this.scolltop[0] -= 300;
          this.scolltop[1] += 290 + this.scolltop[0];
          if (txt[0].innerText == "舒城县") {
            this.scolltop[1] = this.scolltop[0] + 290;
            this.scolltop[2] = this.scolltop[1] + music;
          }
          // 点击平滑过渡
          $("html, body").animate({ scrollTop: this.scolltop[index] }, 500);
          clearTimeout(this.timer);
        }, 300);
      });
    },
  },
  mounted() {
    /* 监听滚动 */
    setTimeout(() => {
      this.$nextTick(() => {
        // 调用，使用this.$nextTick DOM刷新后调用
        // this.sss();
        let arr = [];
        // 获取所有标题
        let category_topArr = $(".category-top");
        //遍历标题push到数组里，每次都获取标题
        for (let i = 0; i < category_topArr.length; i++) {
          arr.push(category_topArr[i].innerHTML);
        }
        // 监听滚动条事件
        $(window).scroll(() => {
          let st = parseInt($(window).scrollTop());
          if (this.scolltop.indexOf(st) !== -1) {
            this.indexNav = this.scolltop.indexOf(st);
          }
        });

        function unique(arr) {
          // 如果新数组的当前元素的索引值 == 该元素在原始数组中的第一个索引，则返回当前元素
          return arr.filter(function (item, index) {
            return arr.indexOf(item, 0) === index;
          });
        }
        this.list = unique(arr);
        this.list.push("回到顶部");
      });
    }, 800);
  },
};
</script>
<style scoped>
.popups {
  position: fixed;
  right: 0;
  bottom: 15%;
  /* background-color: rgba(234, 86, 23); */
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 6px;
  min-width: 50px;
  /* border-radius: 6px; */
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  text-align: center;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.555);
  z-index: 99;
  font-size: 14px;
}
.list_s {
  text-align: center;
}
.list_s li {
  font-size: 14px;
  padding: 0 8px;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid rgba(221, 220, 220, 0.651);
}
.list_s li:last-child {
  background-color: #ea5517;
  color: #fff;
}
.accti {
  color: #ea5517 !important;
}
</style>